import { Action, Dispatch } from 'redux';

import { IAppState } from './reducers';
import {
  IRefreshedTokenData, IUploadSubmitResponse, getStatusForUploadId, IUploadEvent,
} from '../api/vault';

export enum ActionType {
  SubmitUploadStart = 'Upload.SubmitUploadStart',
  SubmitUploadDone = 'Upload.SubmitUploadDone',
  TokenRefreshStart = 'Upload.TokenRefreshStart',
  TokenRefreshDone = 'Upload.TokenRefreshDone',
  GetEventsStart = 'Upload.GetEventsStart',
  GetEventsDone = 'Upload.GetEventsDone'
}

export interface IUploadAction extends Action<ActionType> {
  payload: any
}

export interface IState {
  submitInProgress: boolean,
  uploadState: IUploadSubmitResponse,
  eventRetrievalInProgress: boolean,
  tokensRefreshing: boolean,
  tokenData: IRefreshedTokenData,
  events: IUploadEvent[],
}

const INITIAL_STATE: IState = {
  submitInProgress: false,
  uploadState: null,
  eventRetrievalInProgress: false,
  tokensRefreshing: false,
  tokenData: null,
  events: [],
};

export default (state: IState = INITIAL_STATE, action: IUploadAction) => {
  switch (action.type) {
    case ActionType.SubmitUploadStart:
    case ActionType.SubmitUploadDone:
    case ActionType.TokenRefreshStart:
    case ActionType.TokenRefreshDone:
    case ActionType.GetEventsStart:
    case ActionType.GetEventsDone:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};

export const getEvents = (uploadId: string) => async (dispatch: Dispatch<IUploadAction>, getState: () => IAppState) => {
  dispatch({
    payload: {
      eventRetrievalInProgress: true,
    },
    type: ActionType.GetEventsStart,
  });

  const response = await getStatusForUploadId(uploadId);

  dispatch({
    payload: {
      events: response.data,
      eventRetrievalInProgress: false,
    },
    type: ActionType.GetEventsDone,
  });
};
